var _rect, _path, _g, _path2, _path3, _g2, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 231,
    viewBox: "0 0 221 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 120.018,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1485_30996)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 89.3227C105.039 87.8193 110.247 87.7821 115.14 89.2157L201.676 114.565C207.399 116.241 207.437 124.335 201.729 126.065L115.378 152.232C110.337 153.759 104.95 153.72 99.9323 152.118L18.214 126.038C12.618 124.252 12.6564 116.32 18.2695 114.589L100.166 89.3227Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1485_30996)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 118.018,
    rx: 26.5,
    ry: 2,
    fill: "#7294FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8897 100.557L94.7838 113.823L144.844 82.7556L113.673 73.1961C112.589 72.8637 111.433 72.8452 110.339 73.1428L73.1859 83.2493C70.8959 83.8722 69.1882 85.7864 68.8297 88.1324L67.871 94.4044C67.4919 96.8845 68.6961 99.3387 70.8897 100.557Z",
    fill: "url(#paint1_linear_1485_30996)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9085 100.129C92.9791 97.4736 94.788 95.1804 97.3543 94.4932L141.5 82.6711C145.398 81.6272 149.194 84.6519 149.048 88.6848L148.744 97.0437C148.649 99.6529 146.878 101.901 144.363 102.604L100.286 114.926C96.3968 116.013 92.5656 113.025 92.6729 108.988L92.9085 100.129Z",
    fill: "#4671F6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8897 73.5566L94.7838 86.8229L144.844 55.7556L113.673 46.1961C112.589 45.8637 111.433 45.8452 110.339 46.1428L73.1859 56.2493C70.8959 56.8722 69.1882 58.7864 68.8297 61.1324L67.871 67.4044C67.4919 69.8845 68.6961 72.3387 70.8897 73.5566Z",
    fill: "url(#paint2_linear_1485_30996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9085 73.1294C92.9791 70.4736 94.788 68.1804 97.3543 67.4932L141.5 55.6711C145.398 54.6272 149.194 57.6519 149.048 61.6848L148.744 70.0437C148.649 72.6529 146.878 74.9012 144.363 75.6042L100.286 87.9258C96.3968 89.0131 92.5656 86.025 92.6729 81.9879L92.9085 73.1294Z",
    fill: "#4671F6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8897 47.5566L94.7838 60.8229L144.844 29.7556L113.673 20.1961C112.589 19.8637 111.433 19.8452 110.339 20.1428L73.1859 30.2493C70.8959 30.8722 69.1882 32.7864 68.8297 35.1324L67.871 41.4044C67.4919 43.8845 68.6961 46.3387 70.8897 47.5566Z",
    fill: "url(#paint3_linear_1485_30996)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9085 47.1294C92.9791 44.4736 94.788 42.1804 97.3543 41.4932L141.5 29.6711C145.398 28.6272 149.194 31.6519 149.048 35.6848L148.744 44.0437C148.649 46.6529 146.878 48.9012 144.363 49.6042L100.286 61.9258C96.3968 63.0131 92.5656 60.025 92.6729 55.9879L92.9085 47.1294Z",
    fill: "#4671F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1485_30996",
    x: 69,
    y: 102.018,
    width: 81,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1485_30996"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1485_30996",
    x1: 206,
    y1: 175.018,
    x2: 14,
    y2: 175.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1485_30996",
    x1: 113.569,
    y1: 40.6126,
    x2: 58.2554,
    y2: 118.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1485_30996",
    x1: 113.569,
    y1: 13.6126,
    x2: 58.2554,
    y2: 91.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1485_30996",
    x1: 113.569,
    y1: -12.3874,
    x2: 58.2554,
    y2: 65.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.c50e0c250a4b45f78a110705c4ca812b.svg";
export { ForwardRef as ReactComponent };